module.exports = __webpack_public_path__ + "media/CN_001.bd5d98cd.mp3";